<template>
<div class="chapter">
<div class="inner_page">
<div id="fm6">
<p class="dedication">Elegy for Sabina 1968</p>
<p class="dedication1">Now, sweet witch cat</p>
<p class="dedication1">Free from flesh,</p>
<p class="dedication1">May you hunt</p>
<p class="dedication1">Happily</p>
<p class="dedication1">in the fields of Heaven.</p>
<p class="dedication2">Composed by Grace Warren for Sabina.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Elegy_for_Sabina.vue?0807c5c5